import {map} from "rxjs/operators";
import Constants from "../Constants";
import Api from "../Api";

export interface ElementDataDto {
    id: string,
    type: string,
    name: string,
    description?: string,
    stereotypeId?: string,
}

export interface RelationshipDataDto {
    id: string,
    type: string,
    sourceIdentifier: string,
    targetIdentifier: string,
}

export interface GraphDataDto {
    elementsData: Array<ElementDataDto>,
    relationshipsData: Array<RelationshipDataDto>,
    maxResultsLimit: number,
    maxResultsLimitExceeded: boolean,
}

export default class GraphApiClient {

    public static GRAPH_API_BASE_URL: string = Constants.API_HOST + "/rest-api/graphs";

    findNeighbours(elementIdentifiers: Array<string>): Promise<GraphDataDto> {
        const request = {
            url: `${GraphApiClient.GRAPH_API_BASE_URL}/elements:neighbours`,
            method: "POST",
            body: elementIdentifiers,
        };
        return Api.createAjax(request)
                .pipe(
                        map((response) => response.response as GraphDataDto)
                )
                .toPromise();
    }

    findInterRelationships(elementIdentifiers: Array<string>): Promise<GraphDataDto> {
        const request = {
            url: `${GraphApiClient.GRAPH_API_BASE_URL}/elements:interrelationships`,
            method: "POST",
            body: elementIdentifiers,
        };
        return Api.createAjax(request)
                .pipe(
                        map((response) => response.response as GraphDataDto)
                )
                .toPromise();
    }
}